(function () {
  class BeforeAfterGallery extends HTMLElement {
    constructor() {
      super();
      this.comparison = null;
      this.slider = null;
      this.afterImage = null;
      this.isDragging = false;
    }

    connectedCallback() {
      this.comparison = this.querySelector('[data-comparison]');
      if (this.comparison) {
        this.slider = this.querySelector('[data-slider]');
        this.afterImage = this.querySelector('[data-after-image]');

        if (this.slider && this.afterImage) {
          this.setupBeforeAfter();
        }
      }
    }

    setupBeforeAfter() {
      this.slider.addEventListener('mousedown', this.startDrag.bind(this));
      this.slider.addEventListener('touchstart', this.startDrag.bind(this), { passive: true });

      document.addEventListener('mousemove', this.onDrag.bind(this));
      document.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });

      document.addEventListener('mouseup', this.stopDrag.bind(this));
      document.addEventListener('touchend', this.stopDrag.bind(this));

      this.comparison.addEventListener('click', this.handleClick.bind(this));
    }

    startDrag(e) {
      this.isDragging = true;
      e.preventDefault();
    }

    stopDrag() {
      this.isDragging = false;
    }

    onDrag(e) {
      if (!this.isDragging) return;

      e.preventDefault();
      this.updateSliderPosition(e);
    }

    handleClick(e) {
      if (e.target === this.slider || this.slider.contains(e.target)) return;
      this.updateSliderPosition(e);
    }

    updateSliderPosition(e) {
      const rect = this.comparison.getBoundingClientRect();
      let x;

      if (e.type.includes('touch')) {
        x = e.touches[0].clientX - rect.left;
      } else {
        x = e.clientX - rect.left;
      }

      const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));

      this.slider.style.left = percentage + '%';
      this.afterImage.style.clipPath = `inset(0 0 0 ${percentage}%)`;
    }
  }

  customElements.define('before-after-gallery', BeforeAfterGallery);
})();